import React, { useState, useEffect } from 'react';

import { useMutation } from 'react-query';
import UseToast from 'hooks/use-toast';

import { AddDiscountService, DeleteDiscountService } from 'services/payments';

import ActionButton from '@core/components/actionbutton/ActionButton';
import Message from '@core/components/message/Message';

import WarningIcon from '@core/assets/icons/warning.svg';

import classes from './CartDiscount.module.scss';

const CartDiscount = ({ cartMetaData, refetchMetaData }) => {
	const { toast, ToastContainer } = UseToast();
	const [discountCode, setDiscountCode] = useState('');
	const [responseSuccess, setResponseSuccess] = useState(false);
	const {
		mutate: applyDiscountCode,
		error,
		isLoading: applyDiscountCodeLoading
	} = useMutation(AddDiscountService, {
		onSuccess: () => {
			setResponseSuccess(true);
			refetchMetaData();
		},
		onError: () => {
			setResponseSuccess(false);
		}
	});
	const { mutate: deleteDiscountCode, isLoading: deleteDiscountCodeLoading } = useMutation(
		DeleteDiscountService,
		{
			onSuccess: (data) => {
				toast(data.data.message);
				refetchMetaData();
				setResponseSuccess(false);
			}
		}
	);
	useEffect(() => {
		cartMetaData?.discount_code && setDiscountCode(cartMetaData?.discount_code);
	}, [cartMetaData?.discount_code]);
	return (
		<>
			<div className={`${classes['cart-discount-wrapper']} `}>
				<label
					className={`${classes[!cartMetaData?.can_add_discount ? 'disabled' : '']} 
				d-flex flex-row align-items-center my-4`}
					htmlFor="dicountcode">
					Discount Code
					{!cartMetaData?.can_add_discount && <span className="mx-2">Not Available</span>}
				</label>
				{cartMetaData?.discount_warning && (
					<Message type="warning" text={cartMetaData?.discount_warning} className="my-3" />
				)}
				<div className="d-flex flex-row align-items-center">
					<input
						type="text"
						id="dicountcode"
						name="dicountcode"
						value={discountCode}
						disabled={!cartMetaData?.can_add_discount || cartMetaData?.discount_code}
						className={`${
							responseSuccess || cartMetaData?.discount_code ? classes['success'] : ''
						} ${error ? classes['error'] : ''}`}
						onChange={(e) => setDiscountCode(e.target.value)}
					/>
					<ActionButton
						onClick={() => applyDiscountCode({ code: discountCode })}
						loading={applyDiscountCodeLoading}
						kind="blank"
						disabled={
							!discountCode || !cartMetaData?.can_add_discount || cartMetaData?.discount_code
						}
						className="px-3">
						Apply
					</ActionButton>
				</div>
				{error && (
					<div className={`${classes['response-error']} d-flex flex-row align-items-center my-2`}>
						<WarningIcon />
						{typeof error.response.data.data === 'string'
							? error.response.data.data
							: error.response.data.data?.code[0]}
					</div>
				)}
				{cartMetaData?.discount_code && (
					<>
						<p className={`${classes['discount-meta-message']} py-3`}>
							{cartMetaData?.discount_message}
						</p>
						<ActionButton
							onClick={() => deleteDiscountCode()}
							loading={deleteDiscountCodeLoading}
							kind="blank"
							className="px-0">
							Remove discount
						</ActionButton>
					</>
				)}
			</div>
			<ToastContainer />
		</>
	);
};

export default CartDiscount;
